import AttendApplicationList from './AttendApplicationList';

export default AttendApplicationList;
